import type { CurrentUser } from '@oasis/contracts';
import type { ReactElement } from 'react';

import { formatVersion } from '../../design/format.js';
import { VERSION_INTERFACE } from '../../miseajour/version.js';
import type { RuntimeConfig } from '../../runtime.js';

const ROLE_LABELS: Record<string, string> = {
  admin: 'Administration',
  responsable: 'Responsable',
  gestionnaire: 'Gestionnaire',
  benevole: 'Bénévole',
};

/**
 * Mon compte : rôles, second facteur (état et enrôlement dans la console de compte Keycloak),
 * version de l'interface chargée (vérification après une mise à jour).
 */
export function AccountPage({
  me,
  config,
}: {
  me: CurrentUser;
  config: RuntimeConfig;
}): ReactElement {
  const accountUrl = `${config.identityUrl}/realms/${config.realm}/account/account-security/signing-in`;
  return (
    <section>
      <h1>Mon compte</h1>
      <p>
        <strong>{me.display_name ?? me.username}</strong> ({me.username})
      </p>
      <h2>Rôles</h2>
      <ul>
        {me.roles.length === 0 ? (
          <li>Aucun rôle applicatif</li>
        ) : (
          me.roles.map((r) => <li key={r}>{ROLE_LABELS[r] ?? r}</li>)
        )}
      </ul>
      <h2>Second facteur</h2>
      <p>
        {me.mfa_configured
          ? 'Utilisé lors de cette connexion.'
          : 'Non utilisé lors de cette connexion.'}{' '}
        {me.mfa_required ? 'Obligatoire pour votre rôle.' : 'Facultatif pour votre rôle.'}
      </p>
      <p>
        <a href={accountUrl} target="_blank" rel="noreferrer">
          Configurer une application d'authentification
        </a>
      </p>
      <h2>Version d'Oasis</h2>
      <p>
        Interface chargée :{' '}
        {formatVersion(
          VERSION_INTERFACE === 'dev' ? null : VERSION_INTERFACE,
          'version de développement',
        )}
        .
        {config.version !== undefined &&
          config.version !== VERSION_INTERFACE &&
          VERSION_INTERFACE !== 'dev' &&
          ` Une nouvelle version (${formatVersion(config.version)}) est disponible : rechargez la page.`}
      </p>
    </section>
  );
}
